import { FunctionComponent } from 'react'
import { WidgetProps } from '@rjsf/core'
import { DatePickerWidget } from '@dxp-module/common'
import datePickerStyles from './datePicker.styles'

const DatePicker: FunctionComponent<WidgetProps> = props => {
  const styles = datePickerStyles()

  return (
    <DatePickerWidget
      {...props}
      classes={styles}
      pickerProps={{
        disableFuture: true,
        maxDate: new Date(),
      }}
    />
  )
}

export default DatePicker
